import axios from 'axios';
import router from '@/router/index.js'
import Vue from 'vue'
import bootbox from 'bootbox';
import VueI18n from 'vue-i18n'

var loggedIn = false;

var Auth = {
	install: function (Vue, options) {
		var auth = {
	    	isLoggedIn: isLoggedIn,
	    	login: login,
	    	logout: logout,
			getCookieValue: getCookieValue
	    };

		Vue.$auth = auth;
		Vue.prototype.$auth = auth;
	}
}

Vue.use(Auth)

function isLoggedIn(){
	return loggedIn;
}

function setLanguage(vue, lang) {
	vue.$i18n.locale = lang;
}

function login(vue, user) {
	loggedIn = true;
	setLanguage(vue, user.language)
	Vue.$eventBus.$emit("login", user.userid, user.username);
	axios.defaults.headers.common = {'xsrf-token': getCookieValue('xsrf-token')};
}

function logout(redirect) {
	axios
	.post('login/logout/')
	.then(response => {
		loggedIn = false;
		delete axios.defaults.headers.common["xsrf-token"];
		if(redirect) {
			router.replace({path: '/login', query: {redirect: router.currentRoute.path}});
		} else {
			router.push({path: '/login'});
		}
	 });
}

function getCookieValue(a) {
    var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}



// WEBPACK FOOTER //
// ./src/javascript/plugins/auth.js